var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _Basic = require("../../../../elements/Basic");

var _DropDownArrow = _interopRequireDefault(require("./DropDownArrow"));

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Universal/Basic/DropDown/AbstractDropDown.js";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var AbstractDropDown = function (_React$Component) {
  (0, _inherits2.default)(AbstractDropDown, _React$Component);

  var _super = _createSuper(AbstractDropDown);

  function AbstractDropDown(props) {
    var _this;

    (0, _classCallCheck2.default)(this, AbstractDropDown);
    _this = _super.call(this, props);

    _this.onValueChange = function (value, index) {
      var callback = function callback() {
        if (typeof _this.props.onValueChange === 'function') {
          _this.props.onValueChange(value, index);
        }
      };

      _this.changeIndex(true, function () {
        return index;
      }, callback);
    };

    _this.onLeft = function () {
      _this.changeIndex(_this.state.selectedIndex > 0, function (num1) {
        return num1 - 1;
      }, _this.props.onLeft);
    };

    _this.onRight = function () {
      _this.changeIndex(_this.state.selectedIndex < _this.props.selectOptions.length - 1, function (num1) {
        return num1 + 1;
      }, _this.props.onRight);
    };

    _this.changeIndex = function (check, operation, callback) {
      if (check) {
        var newIndex = operation(_this.state.selectedIndex);

        _this.setState({
          selectedIndex: newIndex
        });

        if (typeof callback === 'function') {
          callback(newIndex);
        }
      }
    };

    _this.state = {
      startIndex: props.selectedIndex || 0,
      selectedIndex: props.selectedIndex || 0
    };
    return _this;
  }

  (0, _createClass2.default)(AbstractDropDown, [{
    key: "renderDropDown",
    value: function renderDropDown(children) {
      var _this$props = this.props,
          disabled = _this$props.disabled,
          withArrows = _this$props.withArrows,
          selectOptions = _this$props.selectOptions,
          arrowStyle = _this$props.arrowStyle,
          invisibleStyle = _this$props.invisibleStyle,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["disabled", "withArrows", "selectOptions", "arrowStyle", "invisibleStyle"]);
      var selectedIndex = this.state.selectedIndex;
      return _react.default.createElement(_Basic.Row, (0, _extends2.default)({
        center: true
      }, rest, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 71,
          columnNumber: 13
        }
      }), withArrows ? _react.default.createElement(_DropDownArrow.default, (0, _extends2.default)({
        isFlex: true,
        center: true,
        disabled: disabled,
        rotate: 180,
        selectedIndex: selectedIndex,
        onPress: this.onLeft,
        invisibleStyle: selectedIndex ? {} : invisibleStyle
      }, arrowStyle, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 73,
          columnNumber: 21
        }
      })) : null, children, withArrows ? _react.default.createElement(_DropDownArrow.default, (0, _extends2.default)({
        isFlex: true,
        center: true,
        disabled: disabled,
        selectedIndex: selectedIndex,
        onPress: this.onRight,
        invisibleStyle: selectOptions && selectedIndex >= selectOptions.length - 1 ? invisibleStyle : {}
      }, arrowStyle, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 86,
          columnNumber: 21
        }
      })) : null);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var selectedIndex = props.selectedIndex;

      if (typeof selectedIndex === 'number' && selectedIndex !== state.startIndex) {
        return {
          selectedIndex: selectedIndex,
          startIndex: selectedIndex
        };
      }

      return {};
    }
  }]);
  return AbstractDropDown;
}(_react.default.Component);

exports.default = AbstractDropDown;